import { type FC, useMemo } from 'react';

import {
  type CustomizeFeature,
  useCustomizeLandContext,
} from '@/features/customizeMyLand/provider';

import CustomizationCard from '../selectionCard/cardVariants/customizationCard';
import { PanelSectionDropdown } from './panelSectionDropdown';

export const DrawSectionDropdown: FC = () => {
  const {
    customizations: { allCustomizations },
  } = useCustomizeLandContext();

  const drawCount: number = allCustomizations?.length || 0;

  const selectionCards = useMemo(() => {
    return (
      <>
        {allCustomizations?.map((feature: CustomizeFeature) => (
          <CustomizationCard key={feature.id} feature={feature} />
        ))}
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allCustomizations, drawCount]);

  if (!drawCount) return null;

  return (
    <PanelSectionDropdown sectionCount={drawCount} title="Drawings">
      {selectionCards}
    </PanelSectionDropdown>
  );
};
